import React from "react"
import { ReferenceField, FunctionField } from "ra-ui-materialui"
import { ShowLink } from "components"

export default props => 
  <ReferenceField label="fields.siteTeam" basePath="/sites" source="SiteId" reference="sites" link={false} allowEmpty sortBy="Site.name" {...props} >
    <FunctionField render={record => <ShowLink record={record} source="name" basePath={`/${record.siteType}s`} />} />
  </ReferenceField>